import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as staticActions from 'shared/ducks/staticDuck';
import {
  IrregularityExaminee,
  IrregularityEntireSite,
  IrregularityEntireRoom,
} from 'features/irregularities';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';

const ENTIRE_SITE = 'test_center';
const EXAMINEE = 'examinee';
const ENTIRE_ROOM = 'room';

const validateExaminees = (examinees) =>
  examinees.length &&
  !examinees.find((examinee) => examinee.firstName === '' || examinee.lastName === '');

class IrregularityInvolvement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      irregularity: props.irregularity,
      errors: {},
    };

    this.getContent = this.getContent.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.onChangeRooms = this.onChangeRooms.bind(this);
    this.onChange = this.onChange.bind(this);
    this.validateRooms = this.validateRooms.bind(this);
  }

  onChangeRooms(rooms) {
    this.setState((prevState) => ({
      irregularity: {
        ...prevState.irregularity,
        irregularityRooms: rooms,
      },
      errors: {},
    }));
  }

  onChange(irregularity, err) {
    this.setState((prevState) => ({
      irregularity,
      errors: {
        ...prevState.errors,
        ...err,
      },
    }));
  }

  getContent() {
    const { irregularity } = this.state;

    switch (irregularity.scope) {
      case EXAMINEE:
        return (
          <IrregularityExaminee
            irregularity={this.props.irregularity}
            hideMatchIdFlag={this.props.tcCycle.testCenterProgram.testCenter.nowManagedFlag}
            rooms={this.props.rooms}
            eventId={this.props.eventId}
            onChange={this.onChange}
            onContinue={this.handleConfirm}
            errors={this.state.errors}
            disableRoom={this.props.disableRoom}
          />
        );
      case ENTIRE_SITE:
        return <IrregularityEntireSite irregularity={this.props.irregularity} />;
      case ENTIRE_ROOM:
        return (
          <IrregularityEntireRoom
            irregularity={this.state.irregularity}
            rooms={this.props.rooms}
            onChange={this.onChangeRooms}
            disableRoom={this.props.disableRoom}
          />
        );
      default:
        return null;
    }
  }

  validateRooms() {
    const { irregularity } = this.state;
    let haveNames = true;

    if (!irregularity.irregularityRooms.length) {
      irregularity.irregularityRooms.push({ error: 'errors.roomNameRequired' });
      this.setState({
        irregularity,
      });
      return !haveNames;
    }

    irregularity.irregularityRooms.forEach((room) => {
      if (!room.roomId) {
        room.error = 'errors.roomNameRequired';
        haveNames = false;
      }
    });

    if (!haveNames) {
      this.setState({
        irregularity,
      });
    }

    return haveNames;
  }

  handleConfirm() {
    const { irregularity } = this.state;
    let haveNames;

    if (irregularity.scope === ENTIRE_ROOM) {
      haveNames = this.validateRooms();

      if (!haveNames) {
        return;
      }
    } else if (irregularity.scope === EXAMINEE) {
      const validExaminees = !!validateExaminees(this.state.irregularity.irregularityExaminees);
      haveNames = this.validateRooms();
      const errors = {};

      if (!validExaminees) {
        errors.examinees = 'errors.examineeNameRequired';
      }

      if (!haveNames) {
        errors.roomName = 'errors.roomNameRequired';
      }

      if (!isEmpty(errors)) {
        this.setState({
          errors,
        });
        return;
      }
    }

    this.props.onContinue(irregularity);
  }

  render() {
    const { irregularity } = this.state;
    return (
      <section className="irregularity-involvement">
        <h4>{irregularity.irregularityType.irregularityCategory.name}</h4>
        <p className="mb-4">{irregularity.irregularityType.name}</p>
        {this.getContent()}
        <div className="buttons-container w-100">
          <button className="btn btn-warn w-50" onClick={this.props.onBack}>
            {this.props.t('common.labels.back')}
          </button>
          <button className="btn btn-action w-50" onClick={this.handleConfirm}>
            {' '}
            {this.props.t('common.labels.continue')}
          </button>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    irregularityStages: state.statics.irregularityStages,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...staticActions }, dispatch) };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(IrregularityInvolvement)
);

IrregularityInvolvement.propTypes = {
  irregularity: PropTypes.shape({
    scope: PropTypes.string,
    irregularityType: PropTypes.shape({
      name: PropTypes.string,
      irregularityCategory: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
    irregularityRooms: PropTypes.arrayOf(
      PropTypes.shape({
        roomId: PropTypes.number,
        error: PropTypes.string,
      })
    ),
    irregularityExaminees: PropTypes.arrayOf(
      PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      })
    ),
  }).isRequired,
  tcCycle: PropTypes.shape({
    testCenterProgram: PropTypes.shape({
      testCenter: PropTypes.shape({
        nowManagedFlag: PropTypes.bool,
      }),
    }),
  }),
  rooms: PropTypes.arrayOf(PropTypes.shape({})),
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableRoom: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  irregularityStages: PropTypes.arrayOf(PropTypes.shape({})),
  actions: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};
